import React, { useEffect, useState } from "react";
import "../../App.css";
import PageTitle from "../../Module/pageTitle";
import { useDispatch, useSelector } from "react-redux";
import { setParentCourse } from "../../Action/courseAction";
import AdminTable from "../../Component/adminTable";
import LabelField from "../../Component/labelField";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import {
  image_size_150,
  validateIsFileImageType,
  validateNameWithoutSpace,
  length_One,
  length_Hundred,
  length_Three,
  containsNumber,
  validateValueWithoutSpace,
  pdf_size_1MB,
  image_size_5MB,
} from "../../Utils/validators";
import {
  validateSubExamNameErrMsg,
  validateIsFileImageTypeErrMsg,
  validateIsNumberOnlyErrMsg,
} from "../../Utils/errorMsg";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import {
  deleteSubExam,
  getExam,
  getSubExamNew,
  updateSubExamNew,
  uploadExamLogo,
} from "../../Action/adminPanelAction";
import Dropdown from "../../Component/dropdown";
import SubmitButton from "../../Component/SubmitButton";
import FormInputField from "../../Component/FormInputField";

function EditSubExam() {
  const dispatch = useDispatch();
  const [subExamId, setSubExamId] = useState("");
  const [exam, setExam] = useState("");
  const [stateName, setStateName] = useState("");
  const [subExam, setSubExam] = useState("");
  const [examLogo, setExamLogo] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [subExamSeoName, setSubExamSeoName] = useState("");
  const [subExamOrder, setSubExamOrder] = useState("");

  const [examList, setExamList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [subExamList, setSubExamList] = useState([]);

  const { isEditMode } = useSelector((state) => ({
    isEditMode: state.courseReducer?.isEditMode,
  }));
  const onChangeSubExamOrder = (value) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        dispatch(showErrorSnackbar("Only Numbers are allowed!"));
        return;
      } else if (!validateValueWithoutSpace(value)) {
        dispatch(showErrorSnackbar(validateIsNumberOnlyErrMsg));
        return;
      } else setSubExamOrder(value);
    }
    setSubExamOrder(value);
  };
  useEffect(() => {
    dispatch(
      getExam((res) => {
        setExamList(res);
      })
    );
  }, []);

  const onChangeExam = (value) => {
    setExam(value);
    setSubExamList([]);
    setStateList([]);
    if (value) {
      dispatch(
        getSubExamNew({ examTypeId: value?._id }, (res) => {
          setSubExamList(res.data?.data);
          setStateList(res?.data?.stateList);
        })
      );
    }
  };

  const onChangeSubExam = (value) => {
    if (value.length >= length_Hundred)
      dispatch(
        showErrorSnackbar(
          `Max Length ${length_Hundred - 1} reached for this field`
        )
      );
    if (!validateNameWithoutSpace(value)) {
      dispatch(showErrorSnackbar(validateSubExamNameErrMsg));
      return;
    }
    setSubExam(value);
  };

  const onChangeSubExamSeoName = (value) => {
    if (value.length >= length_Hundred)
      dispatch(
        showErrorSnackbar(
          `Max Length ${length_Hundred - 1} reached for this field`
        )
      );
    if (!validateNameWithoutSpace(value)) {
      dispatch(showErrorSnackbar(validateSubExamNameErrMsg));
      return;
    }
    setSubExamSeoName(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedImage) {
      dispatch(
        uploadExamLogo(selectedImage, (res) => {
          if (res) {
            const data = {
              name: subExam,
              parentId: exam?._id,
              stateId: stateName?._id,
              file: res?.imageLogo,
              seoName: subExamSeoName,
              order: subExamOrder,
            };
            dispatch(
              updateSubExamNew(data, subExamId, (res) => {
                if (res) {
                  dispatch(setParentCourse("isEditMode", false));
                  setSelectedImage("");
                  setSubExamSeoName("");
                  onChangeExam(exam);
                }
              })
            );
          }
        })
      );
    } else {
      const data = {
        name: subExam,
        parentId: exam?._id,
        stateId: stateName?._id,
        seoName: subExamSeoName,
        order: subExamOrder,
      };
      dispatch(
        updateSubExamNew(data, subExamId, (res) => {
          if (res) {
            dispatch(setParentCourse("isEditMode", false));
            setSelectedImage("");
            setSubExamSeoName("");
            setSubExamOrder("");
            onChangeExam(exam);
          }
        })
      );
    }
  };

  const handleEdit = (value) => {
    setSubExamId(value?._id);
    setStateName(value?.stateIds);
    setSubExam(value?.name);
    setExamLogo(value?.file);
    setSubExamSeoName(value?.seoName);
    setSubExamOrder(value?.order);
    dispatch(setParentCourse("isEditMode", true));
  };

  const handleDelete = (value) => {
    dispatch(
      deleteSubExam(value?._id, () => {
        onChangeExam(exam);
      })
    );
  };

  const onChangeState = (value) => {
    setStateName(value);
  };

  const onChangeLogo = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_5MB) {
      dispatch(showErrorSnackbar("File size should be less than 5 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setExamLogo(reader.result);
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const validations = () => {
    return (
      subExam === "" ||
      subExam.length < 4 ||
      examLogo === "" ||
      subExamSeoName === "" ||
      subExamSeoName?.length < 2 ||
      (stateList.length > 0 && stateName === "")
    );
  };

  const renderEditMode = () => {
    return (
      <div className="col-6">
        {stateList?.length > 0 ? (
          <>
            <div className="d-flex align-items-center">
              <LabelField labelName={"State Name"} isRequired={true} />
              <div className="w-100">
                <Dropdown
                  labelName="Select State Name"
                  setInputText={(value) => onChangeState(value)}
                  options={stateList}
                  value={stateName}
                />
              </div>
            </div>
          </>
        ) : null}
        <div className="d-flex align-items-center">
          <LabelField labelName={"Sub Exam Name"} isRequired={true} />
          <FormInputField
            placeholder={"Enter Sub Exam Name"}
            setInputText={(value) => onChangeSubExam(value)}
            value={subExam}
            maxLength={length_Hundred}
            minLength={length_One}
          />
        </div>
        <ImagePickerAndViewer
          labelName={"Exam Logo"}
          value={examLogo}
          handleChange={(e) => onChangeLogo(e)}
          htmlFor={"photo-upload"}
          isRequired={true}
        />
        <div className="d-flex align-items-center">
          <LabelField labelName={"Sub Exam Name Order"} isRequired={true} />
          <FormInputField
            placeholder={"Enter Sub Exam Name Order"}
            setInputText={(value) => onChangeSubExamOrder(value)}
            value={subExamOrder}
            maxLength={length_Three}
            minLength={length_One}
          />
        </div>
        <div className="d-flex align-items-center">
          <LabelField labelName={"Sub Exam SEO Name"} isRequired={true} />
          <FormInputField
            placeholder={"Enter Sub Exam SEO Name"}
            setInputText={(value) => onChangeSubExamSeoName(value)}
            value={subExamSeoName}
            maxLength={length_Hundred}
            minLength={length_One}
          />
        </div>
        <SubmitButton name="Save and Update" validations={validations()} />
      </div>
    );
  };

  const renderListMode = () => {
    return (
      <AdminTable
        tableData={subExamList ? subExamList : []}
        pagename={"SubExam"}
        tableHead={[
          "S.N",
          "Sub-Exam Name",
          "Logo",
          "SEO Name",
          "Order",
          "Actions",
        ]}
        handleEdit={(value) => handleEdit(value)}
        handleDelete={(value) => handleDelete(value)}
        edit={true}
      />
    );
  };

  const handleCancelEditMode = () => {
    dispatch(setParentCourse("isEditMode", false));
  };

  return (
    <div className="contentBox">
      <PageTitle
        name={"EDIT SUB EXAM NAME"}
        isEditMode={isEditMode}
        onClick={handleCancelEditMode}
      />
      <div className="formDiv contentScrollbar">
        <form className="col-auto formWidth" onSubmit={handleSubmit}>
          <div className="d-flex col-6 align-items-center">
            <LabelField labelName={"Exam Name"} isRequired={true} />
            <div className="w-100">
              <Dropdown
                labelName="Select Exam Name"
                setInputText={(value) => onChangeExam(value)}
                options={examList}
                value={exam}
                disabled={isEditMode}
              />
            </div>
          </div>
          {!isEditMode ? renderListMode() : renderEditMode()}
        </form>
      </div>
    </div>
  );
}

export default EditSubExam;
